<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">

  <app-sub-header [pageTitle]="'Service' | translate"></app-sub-header>

<div class="padded-container">
    <dx-button class="full-width-button" type="default" text="{{ 'ChooseCar' | translate }}" (onClick)="navigateTo('/service-pick-car')"></dx-button>
  
    <div *ngIf="activeUserLocalDataService.activeServiceVoucher">
      <dx-button class="full-width-button" type="default" text="{{ 'FuelPurchase' | translate }} {{ activeUserLocalDataService.activeServiceVoucher.fuelPurchaseCount}}" (onClick)="navigateTo('service-fuel-purchase')"></dx-button>
  
      <dx-button class="full-width-button" type="default" text="{{ 'AdBluePurchase' | translate }} {{ activeUserLocalDataService.activeServiceVoucher.adBluePurchaseCount}}" (onClick)="navigateTo('/service-ad-blue-purchase')"></dx-button>
  
      <dx-button class="full-width-button" type="default" text="{{ 'Comments' | translate }}" (onClick)="navigateTo('/service-comment')"></dx-button>
  
      <dx-button class="full-width-button" type="default" text="{{ 'Problems' | translate }}" (onClick)="navigateTo('/service-manage-car-faults')"></dx-button>
  
      <div *ngIf="!activeUserLocalDataService.activeServiceVoucher?.alcoValue" class="form-layout-item col-md-12 mt-1">
        <dx-button class="full-width-button" type="default" text="{{ 'AlcometerMeasurement' | translate }}" (onClick)="navigateTo('/service-alcometer-value')"></dx-button>
      </div>
  
      <dx-button class="full-width-button" type="default" text="{{ 'VisualDamage' | translate }}" (onClick)="navigateTo('/service-visual-damage-pick-type')"></dx-button>
  
      <dx-button class="full-width-button" type="success" text="{{ 'Finish' | translate }}" (onClick)="navigateTo('/service-voucher-finish')"></dx-button>
    </div>
  </div>
</div>